import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Token de verificação não encontrado.');
      return;
    }

    const verifyUserEmail = async () => {
      try {
        setStatus('verifying');
        const response = await apiService.verifyEmail(token);
        
        if (response.success) {
          setStatus('success');
          setMessage('Email verificado com sucesso! Redirecionando...');
          
          // Salvar no localStorage que o email foi verificado
          localStorage.setItem('waitlistEmailVerified', 'true');
          localStorage.setItem('waitlistUserName', response.name || 'Usuário');
          localStorage.setItem('waitlistUserEmail', response.email || '');
          localStorage.setItem('waitlistUserReferralCode', response.referralCode || '');
          
          // Redirecionar para a página do app após 2 segundos
          setTimeout(() => {
            navigate('/app');
          }, 2000);
        } else {
          setStatus('error');
          setMessage(response.message || 'Erro ao verificar email.');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Erro ao conectar com o servidor. Tente novamente.');
        console.error('Erro na verificação:', error);
      }
    };

    verifyUserEmail();
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #5d4037 0%, #8d6e63 100%)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '15px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '90%'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
            <h2 style={{ color: '#5d4037', marginBottom: '20px' }}>Verificando seu email...</h2>
            <p style={{ color: '#666' }}>Aguarde enquanto confirmamos sua verificação.</p>
            <div style={{
              width: '50px',
              height: '50px',
              border: '5px solid #f3f3f3',
              borderTop: '5px solid #5d4037',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '20px auto'
            }}></div>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
            <h2 style={{ color: '#5d4037', marginBottom: '20px' }}>Email Verificado!</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>{message}</p>
            <div style={{
              width: '50px',
              height: '50px',
              border: '5px solid #f3f3f3',
              borderTop: '5px solid #4CAF50',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '20px auto'
            }}></div>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
            <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>Erro na Verificação</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>{message}</p>
            <button
              onClick={() => navigate('/app')}
              style={{
                background: '#5d4037',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Baixe o app já
            </button>
          </>
        )}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default VerifyEmail; 